import {
  APIListValuesRequest,
  APIListValuesResponse,
  getFetcher,
  ListAttributesRequest,
} from "shared/api/api";
import client, { clientV2 } from "shared/api/axios";
import { createURL } from "shared/api/utils";

const SERVICE_CENTERS_BASE_ROUTE = "serviceCenters";

export const listServiceCentersAttributesRequestURI = (
  params: ListAttributesRequest
): string =>
  clientV2.getUri({
    method: "get",
    url: createURL([SERVICE_CENTERS_BASE_ROUTE, "attributes"]),
    params,
  });

const listServiceCentersValuesRequestURI = ({
  fieldName,
  ...params
}: APIListValuesRequest): string =>
  client.getUri({
    method: "get",
    url: createURL([SERVICE_CENTERS_BASE_ROUTE, "values", fieldName]),
    params,
  });

export const listServiceCentersValues = (args: APIListValuesRequest) =>
  getFetcher<APIListValuesResponse>(listServiceCentersValuesRequestURI(args));
